import { useEffect } from 'react';
import { FlattenInterpolation, ThemeProps } from 'styled-components';
import {
  useModelForm, FormInput, RadioInput, ThemeType, UpdateType,
} from '../../../../..';

export function ModelRadioInput({
  id = '',
  field,
  label = '',
  name = '',
  defaultValue,
  labelStyles = '',
  containerStyles,
  valueOverride,
  errorOverride = '',
  updateOverride,
  disabled = false,
  touchOverride = false,
  mutateValue = (newValue) => newValue,
  onVisibleChange,
  containerCss,
  isInline = false,
  onBlur,
}: {
  id?: string,
  field: string,
  label?: string,
  name?: string,
  defaultValue?: string | boolean,
  labelStyles?: string,
  containerStyles?: string,
  valueOverride?: boolean,
  errorOverride?: string,
  updateOverride?: UpdateType,
  disabled?: boolean,
  touchOverride?: boolean,
  mutateValue?: (newValue: boolean) => boolean,
  onVisibleChange?: (visible: boolean) => void,
  containerCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
  isInline?: boolean,
  onBlur?: () => void,
}) {
  const {
    visible, errors, value, update,
  } = useModelForm(field, valueOverride, errorOverride, updateOverride);

  useEffect(() => {
    onVisibleChange?.(visible);
  }, [visible]);

  return (
    <FormInput visible={visible} css={containerCss}>
      <RadioInput
        id={id}
        label={label}
        name={name}
        value={value === !!defaultValue}
        labelStyles={labelStyles}
        containerStyles={containerStyles}
        errors={errors}
        disabled={disabled}
        touchOverride={touchOverride}
        onChange={(newValue: boolean) => (update({ [field]: mutateValue(newValue && !!defaultValue) }))}
        isInline={isInline}
        visible={visible}
        onBlur={onBlur}
      />
    </FormInput>
  );
}
